import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { WillAdditionalNeedType } from '/@/modules/will/constants/WillAdditionalNeedType';
import { WillAdditionalNeedQuebecType } from '@/modules/will/constants/WillAdditionalNeedQuebecType';

export class WillAdditionalNeed extends BaseEntityModel {
  id: number;

  willId: number;

  type: string;

  details: string;

  constructor(model: Partial<WillAdditionalNeed> = {}) {
    super(model);

    this.id = model.id as number;
    this.willId = model.willId as number;
    this.type = model.type as string;
    this.details = model.details as string;
  }

  getAdditionalNeedInstance(): { value: string; description: string } {
    const additionalNeedTypes: WillAdditionalNeedType | WillAdditionalNeedQuebecType = {
      ...WillAdditionalNeedType.getKeyValues(),
      ...WillAdditionalNeedQuebecType.getKeyValues()
    };

    return Object.values(additionalNeedTypes).find(
      (val: Record<string, null>) => val.key === this.type
    );
  }

  get title(): string {
    return this.getAdditionalNeedInstance().value;
  }

  get description(): string {
    return this.getAdditionalNeedInstance().description;
  }
}
